// import * as CryptoJS from "crypto-js";
// import Moment from 'moment';
import { decryptV2 } from "../helpers/Cryptography/CryptoV2";

// const key = CryptoJS.enc.Utf8.parse("M@h1ndra$1234567");
// // const iv = CryptoJS.enc.Utf8.parse("0001000100010001");
// let key = CryptoJS.enc.Utf8.parse(Moment().format("DDMMYYYY"));
// let iv = CryptoJS.enc.Utf8.parse(Moment().format("YYYYMMDD"));

const Decrypt = (encData) => {
  return decryptV2(encData);
  // let decryptedBytes;
  // let decryptedText;

  // decryptedBytes = CryptoJS.AES.decrypt(encData, key, {
  //   keySize: 128 / 8,
  //   iv: iv,
  //   mode: CryptoJS.mode.CBC,
  //   padding: CryptoJS.pad.Pkcs7,
  // });
  // decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
  // return decryptedText;
};

export default Decrypt;
